import LostItemsSearch from "./../../features/LostFound/components/LostItemsSearch";
import PrivacyAgree from "../../features/LostFound/components/modal/PrivacyAgree";
import Header from "#src/components/Header/Header.jsx";
import { useState } from "react";

const LostItemsSearchPage = () => {
  const [modalIsOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };
  return (
    <>
      <section className="p-hasHeader">
        <Header title="습득물 조회" />

        <LostItemsSearch openModal={openModal} closeModal={closeModal} />
      </section>
      <PrivacyAgree isOpen={modalIsOpen} onRequestClose={closeModal} />
    </>
  );
};

export default LostItemsSearchPage;
